import { Map } from "immutable";
import { Action, reducerFn, ReducerState } from "../../helpers/reducers";
import { STATUS_USER_LOADED } from "./actions";

interface Status {
    userLoaded: boolean;
}
type StatusAction = Action<Status>;

const initialState = Map({
    userLoaded: false,
});

const fnMap = {
    [STATUS_USER_LOADED]: (s: ReducerState, a: StatusAction) =>
        s.set("userLoaded", a.payload),
};
export const statusReducer = reducerFn("status", initialState, fnMap);
